import { useEffect, useState } from "react";
import { avisosApi } from "./avisos.service";
import { push } from "../navigation/v2/sales/push";

/**
 * El número de avisos sin leer (lo arranca AvisosEnVivo). Una sola consulta para la pestaña: al entrar, con el aviso al instante
 * (evento "aviso" de wapp-push), al volver a la pestaña y cada minuto de respaldo.
 */
let valor = 0;
const oyentes = new Set<(n: number) => void>();
let activo = false;
let espera: any = null;
let ultima = 0;

const publicar = (n: number) => { valor = n; oyentes.forEach((fn) => fn(n)); };

/*
	Ráfagas (29-oct-2026): el aviso diario de las 9 am llega ~100 veces seguidas por persona y cada «aviso» de wapp-push
	disparaba su propia consulta en cada pestaña abierta → "Demasiados intentos". `juntarRafaga` espera a que la ráfaga
	se calme (`espera` ms sin avisos nuevos) y hace UNA llamada; si la ráfaga sigue, de todos modos llama cada `tope` ms.
*/
export const juntarRafaga = (fn: () => void, espera = 1500, tope = 5000): { pedir: () => void; cancelar: () => void } => {
	let t: any = null;
	let primera = 0;
	const disparar = () => { t = null; primera = 0; fn(); };
	return {
		pedir: () => {
			const ahora = Date.now();
			if (!primera) { primera = ahora; }
			if (t) { clearTimeout(t); }
			const falta = Math.max(0, Math.min(espera, primera + tope - ahora));
			t = setTimeout(disparar, falta);
		},
		cancelar: () => { if (t) { clearTimeout(t); } t = null; primera = 0; }
	};
};

export const refrescarConteo = (ms = 300) => {
	if (!activo || espera) return;
	espera = setTimeout(async () => {
		espera = null;
		try { publicar(Number((await avisosApi.conteo()).data.no_leidos) || 0); ultima = Date.now(); } catch { /* se queda el de antes */ }
	}, ms);
};

export const ponerConteo = (n: number) => publicar(Math.max(0, n));

/** conPush: abre (o comparte) la conexión de wapp-push; sin ella, cada minuto. */
export const iniciarConteo = (campusId: number, conPush: boolean): (() => void) => {
	activo = true;
	const soltar = conPush ? push.usar(campusId) : () => undefined;
	const rafaga = juntarRafaga(() => refrescarConteo(0));
	const quitar = push.on("aviso", rafaga.pedir);
	// Al volver solo si lo último tiene más de 30 s; el respaldo, cada minuto sin conexión al instante y cada 3 con ella
	// (el aviso nuevo llega por wapp-push; 12-oct-2026: ~190 consultas/min en hora pico solo por el respaldo).
	const alVolver = () => { if (document.visibilityState === "visible" && Date.now() - ultima > 30000) refrescarConteo(200); };
	document.addEventListener("visibilitychange", alVolver);
	const ciclo = setInterval(() => {
		if (document.visibilityState === "visible" && Date.now() - ultima > (push.conectado ? 175000 : 55000)) refrescarConteo(0);
	}, 60000);
	refrescarConteo(0);
	return () => {
		activo = false;
		soltar(); quitar(); rafaga.cancelar();
		document.removeEventListener("visibilitychange", alVolver);
		clearInterval(ciclo);
		clearTimeout(espera); espera = null;
		publicar(0);
	};
};

export const useConteoAvisos = (): number => {
	const [n, setN] = useState(valor);
	useEffect(() => { oyentes.add(setN); setN(valor); return () => { oyentes.delete(setN); }; }, []);
	return n;
};
